import React from "react";
import './Banner500.css';
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";

function Banner500(props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    return (
            <div className="Banner500">
            <div className="Banner500Right">
                <div className="Banner500Title">
                    <TextSource ArrIndex= 'index0105'>Free Cheese</TextSource>
                    <br/>
                    <TextSource ArrIndex= 'index0110'>Without a Mousetrap</TextSource>
                </div>
                <div className="Banner500Text">
                    <TextSource ArrIndex= 'index0115'>AVAILABLE FOR MULTIPLE CLIENT</TextSource>
                    <br/>
                    <TextSource ArrIndex= 'index0120'>WITHDRAWABLE AT ANY TIME</TextSource>
                </div>
                <div className="Banner500Button ButtonOut">
                    <ChangeLink to={'/bonuses'} lang={props.lang} style={{textDecoration: 'none'}}>
                        <div className='ButtonYellow'>
                            <TextSource ArrIndex= 'index0125'>FIND OUT MORE</TextSource>
                        </div>
                    </ChangeLink>
                </div>
            </div>
            </div>
    )}

export default Banner500





